export enum AuthEnum {
  AUTH_TOKEN = "x-auth-token",
}

export enum BrandRole {
  ADMIN = 'ADMIN',
  READ = 'READ',
  NONE = 'NONE'
};

export type JwtSchema = {
  name: string;
  id: number;
  brand_id: string;
  email: string;
  phone: string | null;
  user_enabled: boolean;
  created_at: string;
  updated_at: string;
  brand_role: BrandRole;
  sub: string;
}

